export type VersionGitInfo = {
  revision?: string
  ref?: string
  build_date?: string
}

export type VersionInfo = {
  version: string | null
  git: VersionGitInfo
  environment: string
  deploy_env: string
}

const PRODUCTION_DEPLOY_ENVS = new Set(['prd', 'production'])

export const isProductionDeployEnv = (deployEnv: string) =>
  PRODUCTION_DEPLOY_ENVS.has(deployEnv)
